import { UserViewObject } from '@/api';
import { IdBulkFetch } from '@/core/bulk/idBulkFetch';
import usersApiService from '@/core/api/controllers/usersApi.service';

class UserService extends IdBulkFetch<UserViewObject, string> {
    protected async apiCall(userIds: string[]): Promise<{ [key: string]: UserViewObject }> {
        const result = await usersApiService.getUsersById({ userIds });
        return result?.users.reduce((a, b) => {
            a[b.id] = b;
            return a;
        }, {}) ?? {};
    }
}

export default new UserService('UserService');
